import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const pageTitles = {
  '/admin': 'Dashboard',
  '/tarayici': 'QR-Scanner',
  '/uyeler': 'Mitglieder',
  '/basvurular': 'Bewerbungen',
  '/aidatlar': 'Beiträge',
  '/odemeler': 'Zahlungen',
  '/giris-kayitlari': 'Eintrittsprotokolle',
  '/duyurular': 'Ankündigungen',
  '/raporlar': 'Berichte',
  '/website-yonetimi': 'Website-Verwaltung',
  '/ayarlar': 'Einstellungen',
};

export default function MainLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const basePath = '/' + (location.pathname.split('/')[1] || '');
  const title = pageTitles[basePath] || 'Dashboard';

  return (
    <div className="min-h-screen bg-gray-50 flex overflow-hidden">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
        <Header
          title={title}
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        />

        <main className="flex-1 p-4 sm:p-6 overflow-x-hidden overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
